import { useState } from "react";
import { useAppSelector } from "../../../app/store";
import CEOImg from "../../../assets/images/avatar.svg";
import TopCard from "../../../components/common/TopCard";
import { useGetEmployeeDetailsQuery } from "../../../features/employee/employeeApi";
import SidebarLayout from "../../../layouts/SidebarLayout";
import CompanyProfile from "./view/CompanyProfile";
import PersonalProfile from "./view/PersonalProfile";
import ProfileChangePassword from "./view/ProfileChangePassword";

export const profileDetailsList = [
  "Personal Profile",
  "Company Profile",
  "Change Password",
] as const;
type ItemType = (typeof profileDetailsList)[number];

export default function Profile() {
  const [item, setItem] = useState<ItemType | number>("Personal Profile");
  const { authInfo } = useAppSelector((state) => state.auth);
  const { data } = useGetEmployeeDetailsQuery(authInfo?.id?.toString() || "", {
    skip: !authInfo?.id,
  });

  const profile = data?.data?.employee;

  function getInfoData() {
    if (item === "Personal Profile") {
      return <PersonalProfile />;
    } else if (item === "Company Profile") {
      return <CompanyProfile />;
    } else if (item === "Change Password") {
      return <ProfileChangePassword />;
    } else {
      return undefined;
    }
  }

  return (
    <SidebarLayout title="Profile">
      <TopCard
        size={16}
        align="center"
        leftChildren={
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div className="col-span-1 md:col-span-4 bg-gray-200 pe-4 border-r border-transparent md:border-extra-light">
              <div className="flex items-center gap-4 min-w-72">
                <div className="w-14 h-14">
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={profile?.member?.profile?.pro_pic || CEOImg}
                    alt="User_Image"
                  />
                </div>
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-body text-lg font-semibold leading-normal">
                    {profile?.member?.profile?.name}
                  </h3>

                  <p className="text-body-text text-sm font-medium leading-normal">
                    {profile?.role?.name}
                  </p>
                </div>
              </div>

              <ul className="pt-4">
                {profileDetailsList?.map((el) => (
                  <li
                    key={el}
                    onClick={() => {
                      setItem(el);
                    }}
                    className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                      el === item
                        ? "bg-[#fff1eb]/50 text-primary"
                        : "text-muted"
                    }`}
                  >
                    {el}
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-span-1 md:col-span-8 bg-gray-200 ">
              <div className="md:col-span-3 p-2">{getInfoData()}</div>
            </div>
          </div>
        }
      ></TopCard>
    </SidebarLayout>
  );
}
